const defaultSingleParams = {
  // "userId": "123123123",
  // "competitionId": 1,
  // "channelId": 1,
  "regionId": '',
  // "entryTypeId": 1,
  // "professionalId": 2,
  // "entryGroupId": 1,
  "repertoire": "",
  "agency": "",
  // "agencyPhone": "",
  "teacherName": "",
  // "teacherPhone": "",
  "isSingle": true,
  competitionMode: '',
  videoUrl: '',
  // postAddress: '',
  "contestants": [
    {
      "realName": "",
      "gender": 1,
      "nation": '',
      "birthForYear": '',
      "certificateType": '身份证',
      "certificateCode": "",
      "parentName": "",
      "mobile": "",
      "postAddress": "",
      picUrl: '',
      currentSchool: '',
      schoolAddress: '',
    }
  ]
}

const defaultMultiParams = {
  // "userId": "123123123",
  // "competitionId": 1,
  // "channelId": 1,
  "regionId": "",
  // "entryTypeId": 1,
  // "professionalId": 2,
  // "entryGroupId": 1,
  "repertoire": "",
  "agency": "",
  // "agencyPhone": "",
  "teamName": "",
  "teacherName": "",
  "teacherPhone": "",
  // "certificateType": "",
  // "certificateCode": "",
  "isSingle": false,
  postAddress: '',
  competitionMode: '',
  videoUrl: '',
  "contestants": []
}

const state = {
  // 参赛类型
  competitiontypes: [],
  // 选择的参赛类型
  selectCompetitiontype: null,
  // 选择的器乐
  selectProfessional: null,
  // 选择的分组
  group: null,
  // 单人报名
  singleParams: {
    // "userId": "123123123",
    // "competitionId": 1,
    // "channelId": 1,
    "regionId": '',
    // "entryTypeId": 1,
    // "professionalId": 2,
    // "entryGroupId": 1,
    "repertoire": "",
    "agency": "",
    teacherName: '',
    // "agencyPhone": "",
    "isSingle": true,
    // postAddress: '',
    competitionMode: '',
    "contestants": [
      {
        "realName": "",
        "gender": 1,
        "nation": '',
        "birthForYear": '',
        "certificateType": '身份证',
        "certificateCode": "",
        "parentName": "",
        "mobile": "",
        "postAddress": "",
        picUrl: '',
        currentSchool: '',
        schoolAddress: '',
      }
    ]
  },
  // 团队报名
  multiParams: {
    // "userId": "123123123",
    // "competitionId": 1,
    // "channelId": 1,
    "regionId": "",
    // "entryTypeId": 1,
    // "professionalId": 2,
    // "entryGroupId": 1,
    "repertoire": "",
    "agency": "",
    // "agencyPhone": "",
    "teamName": "",
    "teacherName": "",
    "teacherPhone": "",
    // "certificateType": "",
    // "certificateCode": "",
    "isSingle": false,
    postAddress: '',
    competitionMode: '',
    "contestants": [
      // {
      //   "realName": "",
      //   "gender": "",
      //   "nation": '',
      //   "birthForYear": '',
      //   "certificateType": "身份证",
      //   "certificateCode": "",
      //   "parentName": "",
      //   "mobile": "",
      //   "picUrl": "",
      //   "currentSchool": "",
      //   "schoolAddress": "",
      //   "professionalName": "",
      // }
    ]
  },
  setRegionIdIndex: [],
  channelId: '',
  competitionId: '',
  // 渠道列表
  channels: [],
  competitionIds: []
}

const mutations = {
  setCompetitiontypes: (state, competitiontypes) => {
    state.competitiontypes = competitiontypes
  },
  setSelectCompetitiontype: (state, selectCompetitiontype) => {
    state.selectCompetitiontype = selectCompetitiontype
  },
  setSelectProfessional: (state, selectProfessional) => {
    state.selectProfessional = selectProfessional
  },
  setChannels: (state, channels) => {
    state.channels = channels
  },
  setGroup: (state, group) => {
    state.group = group
  },
  setSingleContestant: (state, singleContestant) => {
    let contestant = state.singleParams.contestants[0]
    state.singleParams.contestants[0] = Object.assign(contestant, singleContestant)
  },
  setSingleForm: (state, singleForm) => {
    let form = state.singleParams
    state.singleParams = Object.assign(form, singleForm)
  },
  resetSingleForm: (state) => {
    state.singleParams = JSON.parse(JSON.stringify(defaultSingleParams))
  },
  setMultiContestant: (state, multiContestant) => {
    state.multiParams.contestants = multiContestant
  },
  setMultiForm: (state, multiForm) => {
    let form = state.multiParams
    state.multiParams = Object.assign(form, multiForm)
  },
  resetMultiForm: (state) => {
    state.multiParams = JSON.parse(JSON.stringify(defaultMultiParams))
  },
  setRegionIdIndex: (state, regionIdIndex) => {
    state.regionIdIndex = regionIdIndex
  },
  setCompetitionIds: (state, competitionIds) => {
    state.competitionIds = competitionIds
  },
  setChannelId: (state, channelId) => {
    defaultSingleParams.channelId = channelId
    defaultMultiParams.channelId = channelId
    state.singleParams.channelId = channelId
    state.multiParams.channelId = channelId
    state.channelId = channelId
  },
  setCompetitionId: (state, competitionId) => {
    defaultSingleParams.competitionId = competitionId
    defaultMultiParams.competitionId = competitionId
    state.singleParams.competitionId = competitionId
    state.multiParams.competitionId = competitionId
    state.competitionId = competitionId
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
